import { api, unwrapList } from '../lib/axios';

export interface AppNotification {
  id: string;
  userId: string;
  type: string;
  payload?: Record<string, unknown>;
  readAt: string | null;
  createdAt: string;
}

export async function getNotifications(unreadOnly = false): Promise<AppNotification[]> {
  const { data } = await api.get<AppNotification[] | { data: AppNotification[] }>(
    `/notifications${unreadOnly ? '?unread=true' : ''}`,
  );
  return unwrapList(data);
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.patch(`/notifications/${id}/read`);
}
